import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { selectIsAuth, selectUserData } from '@/reducers/userDataReducer'

export type SentryIdentifyProps = {
  children: React.ReactNode
}

/**
 * Keeps the Sentry-reported user in sync with the app's auth state, mirroring PostHogIdentify
 * (see post-hog-provider.tsx). Without this every Sentry issue shows 0 affected users, making
 * real-world impact impossible to judge. Only an id + role are sent, no PII — same convention
 * PostHog already uses.
 */
export const SentryIdentify = ({ children }: SentryIdentifyProps) => {
  // TODO: migrate off redux
  const isAuth = useSelector(selectIsAuth)
  const userData = useSelector(selectUserData)

  useEffect(() => {
    if (isAuth && userData?.user?.id) {
      Sentry.setUser({ id: userData.user.id.toString(), role: userData.user.role })
    } else {
      Sentry.setUser(null)
    }
  }, [isAuth, userData])

  return <>{children}</>
}
